import React from 'react';

const Terms = () => {
  return (
    <div className="policy-page">
    <div className="container">
      <div className="policy-header">
      <h1>Terms of Service</h1>
<p>Last updated: March 15, 2025</p>

      </div>
  
      <div className="policy-content">
      <div className="policy-section">
  <p>Please read these Terms of Service ("Terms") carefully before using the website https://nzsocialge.com (the "Service") operated by https://nzsocialge.com ("we", "our", or "us").</p>
  <p>Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users, and others who access or use the Service.</p>
  <p>By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part of the terms, you may not access the Service.</p>
  <p>Before proceeding to download the application, please read our Terms of Service. By downloading and using our app, you agree to the following:</p>

  <ul>
    <li>You have read and fully understood our Terms of Service.</li>
    <li>You agree to use our service in accordance with the law.</li>
    <li>You consent to the processing of your personal data in accordance with our Privacy Policy.</li>
  </ul>

  <p>You have read and accepted the rules of responsible gaming.</p>

  <h2>Key Provisions</h2>
  <p>1.1. These Terms define the conditions for the use of interactive services ("Services") provided by the Provider through the website https://nzsocialge.com ("Service").</p>
  <p>1.2. The services provided by the Provider include access to an challengearenant-focused gaming platform for registered users ("Participants"). Users can interact, exchange information, and discuss topics related to games.</p>
  <p>1.3. Within the provided services, participants can play games where the outcome depends on their reaction speed, agility, and observation skills. To win, a player must score the highest points.</p>
  <p>1.4. Using and registering for the Service constitutes acceptance of these Terms. Users who access the Service without registering are also required to comply with these Terms, in accordance with applicable electronic services legislation.</p>
  <p>1.5. The Provider emphasizes that no individual agreements are made with users or participants. All users of services provided by the Provider are subject to these Terms.</p>
  <p>1.6. Full access to all games offered by the Service depends on the technical compatibility of the user's computer or mobile device with the Service.</p>
  <p>1.7. The Provider is not responsible for any lack of availability of the Service due to factors beyond their control or unforeseen circumstances.</p>

  <h2>Responsible Gaming Rules</h2>
  <p>The main goal of our online service is to provide users with challengearenant and to expand their knowledge about games. By making this service publicly available, we hope all users engage with it for this purpose. However, for some users, use of the service may become excessive. While rare, such situations can be avoided by following these basic rules:</p>

  <ul>
    <li>Play only for fun.</li>
    <li>Understand that points have no real-world value and should be considered a personal achievement.</li>
    <li>Try to win, but avoid revenge gaming.</li>
    <li>Do not play when feeling sad, tired, or frustrated.</li>
  </ul>

  <h2>Contact Us</h2>
  <p>If you have any questions about these Terms, please contact us.</p>
</div>

      </div>
    </div>
  </div>
  
  );
};

export default Terms; 